module.exports = __webpack_public_path__ + "img/review-author.png";